import { inplayHomepageUrl, inplayEventsUrl } from '../../../spa/Utils/LocalizedUrls';
import { seoUrlInplay } from '../../../spa/Utils/SeoUrls';

export const IPW_API_URL = '/inplay-req/featured';
export const IPW_BASE_INPLAY_LINK = `/${inplayHomepageUrl()}/${inplayEventsUrl()}`;
export const IPW_MAIN_CLASS_NAME = 'bb-inplay-widget';
export const IPW_TITLE_ICON_CLASS_NAME = 'inplay';
export const IPW_TITLE_LINK = seoUrlInplay();

const I18N_PREFIX = 'inplay';

export const IPW_FEATURED_IN_PLAY_TEXT = `${I18N_PREFIX}.featured_ip`;
export const IPW_ALL_MARKETS_TEXT = `${I18N_PREFIX}.all_markets`;
export const COMPETITOR_SIDES_TEXT = 'sport_event.sides';

export const IPW_INPLAY = 'inplay';
export const IPW_BET_CARD_GTM_TAG = 'bet-card';
export const IPW_HOMEPAGE_NAME = 'inplay-widget';
export const IPW_INPLAY_NAME = 'featured-inplay';
export const IPW_GTM_SEE_ALL = 'see-all';

export const IPW_WS_HANDLER_COMPONENT_NAME = 'InplayWidget';
